import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { del } from "../../lib/request"

export const deleteAlertGroup = createAsyncThunk(
  "alertGroup/delete",
  async (groupId, { rejectWithValue, getState }) => {
    try {
      const state = getState()
      const token = state.auth?.token

      if (!token) {
        throw new Error("Authentication required")
      }

      if (!groupId) {
        throw new Error("Group ID is required")
      }

      const endpoint = `alert-groups/${groupId}`

      await del(endpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      return { groupId }
    } catch (err) {
      return rejectWithValue(err?.message || "Failed to delete group")
    }
  }
)

const initialState = {
  status: "idle",
  error: null,
  deletedGroupId: null,
}

const alertGroupDeleteSlice = createSlice({
  name: "alertGroupDelete",
  initialState,
  reducers: {
    clearDeleteGroupError: (state) => {
      state.error = null
    },
    resetDeleteGroupStatus: (state) => {
      state.status = "idle"
      state.error = null
      state.deletedGroupId = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteAlertGroup.pending, (state) => {
        state.status = "loading"
        state.error = null
      })
      .addCase(deleteAlertGroup.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.deletedGroupId = action.payload.groupId
      })
      .addCase(deleteAlertGroup.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
  },
})

export const {
  clearDeleteGroupError,
  resetDeleteGroupStatus,
} = alertGroupDeleteSlice.actions

export default alertGroupDeleteSlice.reducer
